/* DuctlessAire accessories page: cards, kit builder, filter bar.
   Plain JS, no dependencies. Safe to load more than once. */
(function () {
  if (window.daAccessoriesLoaded) return;
  window.daAccessoriesLoaded = true;

  function routes() {
    var r = window.daRoutes || {};
    return { add: (r.add || '/cart/add') + '.js', cart: r.cart || '/cart', cartJs: (r.cart || '/cart') + '.js' };
  }

  function formatMoney(cents) {
    var fmt = ((window.daRoutes && window.daRoutes.moneyFormat) || '${{amount}}').replace(/<[^>]*>/g, '');
    var n = (cents || 0) / 100;
    var withDelims = function (num, dec, thou, decSep) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return withDelims(n, 0, ',', '.');
      if (key === 'amount_with_comma_separator') return withDelims(n, 2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return withDelims(n, 0, '.', ',');
      return withDelims(n, 2, ',', '.');
    });
  }

  function addItems(items) {
    return fetch(routes().add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        log('add.js', res.status, data);
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        document.dispatchEvent(new CustomEvent('da:cart-updated', { detail: data }));
        return data;
      });
    });
  }

  /* ---------- Theme cart drawer integration ----------
     1. Fire the theme's documented refresh event (Concept / RoarTheme: 'cart:refresh').
        Dispatched on <html> with bubbles so listeners on html, document or window all receive it.
     2. Check whether a cart drawer actually became visible.
     3. If not: re-fetch this page, swap in fresh cart markup (drawer + header count) and
        open the drawer through the header cart icon.
     4. If no drawer can be found at all, the caller shows the confirmation message instead.
     Add ?da_debug=1 to the page URL to log each step in the browser console. */
  var DEBUG = /[?&]da_debug=1/.test(window.location.search);
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[DA cart]'].concat([].slice.call(arguments))); }

  var DRAWER_SEL = 'cart-drawer, [id*="cart-drawer" i], [id*="cartdrawer" i], [id*="cart_drawer" i], [class*="cart-drawer" i], [data-cart-drawer], [id*="drawer" i][id*="cart" i]';

  function isVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 40 || r.height < 40) return false;
    if (r.right <= 0 || r.left >= window.innerWidth || r.bottom <= 0 || r.top >= window.innerHeight) return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && Number(cs.opacity) > 0.05;
  }

  function drawerOpen() {
    var found = Array.prototype.some.call(document.querySelectorAll(DRAWER_SEL), function (el) {
      if (el.closest('.da-section')) return false;
      return isVisible(el) || Array.prototype.some.call(el.children, isVisible);
    });
    log('drawer visible:', found);
    return found;
  }

  function hasDrawer() {
    return Array.prototype.some.call(document.querySelectorAll(DRAWER_SEL), function (el) { return !el.closest('.da-section'); });
  }

  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function swapCartMarkup() {
    // Fresh copy of this page, then replace every theme element whose id mentions "cart"
    // (drawer contents, header count bubble) with the up-to-date version.
    return fetch(window.location.pathname + window.location.search, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var swapped = 0;
        var nodes = Array.prototype.slice.call(document.querySelectorAll('[id*="cart" i]'));
        nodes.forEach(function (el) {
          if (el.closest('.da-section') || el.tagName === 'SCRIPT' || el.tagName === 'FORM' && el.closest('.da-acc-card')) return;
          // only outermost matches, so nested ids are not swapped twice
          var parent = el.parentElement && el.parentElement.closest('[id*="cart" i]');
          if (parent && !parent.closest('.da-section')) return;
          var fresh = doc.getElementById(el.id);
          if (fresh && fresh.innerHTML !== el.innerHTML) { el.innerHTML = fresh.innerHTML; swapped++; }
        });
        log('swapped cart elements:', swapped);
        return swapped;
      })
      .catch(function (e) { log('swap failed', e); return 0; });
  }

  function clickCartIcon() {
    var link = document.querySelector('header a[href$="/cart"], [id*="header" i] a[href$="/cart"], a[href$="/cart"][aria-controls], [data-cart-toggle], [data-drawer-toggle*="cart" i]');
    if (!link) { log('no header cart icon found'); return false; }
    log('opening drawer via', link);
    link.click();
    return true;
  }

  // Returns a promise that resolves true when the theme's drawer is showing the new cart.
  function showInThemeCart(open) {
    var evt = new CustomEvent('cart:refresh', { bubbles: true, detail: { open: !!open } });
    document.documentElement.dispatchEvent(evt);
    log('dispatched cart:refresh', { open: !!open });
    if (!open) return swapCartMarkup().then(function () { return false; });
    return wait(700).then(function () {
      if (drawerOpen()) return true;
      if (!hasDrawer()) { log('theme has no cart drawer on this page'); return swapCartMarkup().then(function () { return false; }); }
      return swapCartMarkup().then(function () {
        if (!clickCartIcon()) return false;
        return wait(600).then(drawerOpen);
      });
    });
  }

  var toastEl, toastTimer;
  function toast(message, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'da-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('is-error', !!isError);
    toastEl.innerHTML = '<span>' + message + '</span>' + (isError ? '' : '<a href="' + routes().cart + '">View cart</a>');
    toastEl.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-open'); }, 5000);
    if (!isError) {
      fetch(routes().cartJs, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var span = toastEl.querySelector('span');
          if (span) span.textContent = message + ' (' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ' in cart)';
        }).catch(function () {});
    }
  }

  /* ---------- Accessory card ---------- */
  if (!customElements.get('da-acc-card')) {
    customElements.define('da-acc-card', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.select = this.querySelector('[data-variant]');
        this.btn = this.querySelector('[data-add]');
        this.price = this.querySelector('[data-price]');
        if (this.select) {
          this.select.addEventListener('change', () => this.update());
          this.update();
        }
        if (this.form && (this.dataset.mode === 'toast' || this.dataset.mode === 'drawer')) {
          this.form.addEventListener('submit', (e) => { e.preventDefault(); this.add(); });
        }
      }
      update() {
        var o = this.select.selectedOptions[0];
        if (!o) return;
        var ok = o.dataset.available === 'true';
        this.btn.disabled = !ok;
        this.btn.textContent = ok ? this.dataset.addLabel : this.dataset.soonLabel;
        if (this.price) {
          this.price.innerHTML = '<strong>' + o.dataset.priceHtml + '</strong>' + (o.dataset.compareHtml ? ' <s>' + o.dataset.compareHtml + '</s>' : '');
        }
      }
      add() {
        var id = new FormData(this.form).get('id');
        var label = this.btn.textContent;
        this.btn.disabled = true;
        this.btn.textContent = 'Adding...';
        var title = (this.querySelector('.da-acc-card__title') || {}).textContent || 'Item';
        addItems([{ id: Number(id), quantity: 1 }])
          .then(() => {
            var msg = 'Added: ' + title.trim();
            if (this.dataset.mode === 'drawer') {
              return showInThemeCart(true).then((shown) => { if (!shown) toast(msg); });
            }
            showInThemeCart(false);
            toast(msg);
          })
          .catch((err) => toast(err.message, true))
          .finally(() => { this.btn.disabled = false; this.btn.textContent = label; if (this.select) this.update(); });
      }
    });
  }

  /* ---------- Complete installation kit ---------- */
  if (!customElements.get('da-acc-bundle')) {
    customElements.define('da-acc-bundle', class extends HTMLElement {
      connectedCallback() {
        this.slots = Array.prototype.slice.call(this.querySelectorAll('[data-slot]'));
        this.totalEl = this.querySelector('[data-total]');
        this.countEl = this.querySelector('[data-count]');
        this.btn = this.querySelector('[data-bundle-add]');
        this.msg = this.querySelector('[data-bundle-msg]');
        this.slots.forEach((slot) => {
          var sel = slot.querySelector('select');
          var cb = slot.querySelector('input[type="checkbox"]');
          if (sel) sel.addEventListener('change', () => { if (slot.dataset.sync === 'length') this.syncLength(sel); this.refresh(); });
          if (cb) cb.addEventListener('change', () => this.refresh());
        });
        if (this.btn) this.btn.addEventListener('click', () => this.add());
        var first = this.slots.find((s) => s.dataset.sync === 'length' && s.querySelector('select'));
        if (first) this.syncLength(first.querySelector('select'));
        this.refresh();
      }
      matchFilter(state) {
        if (!state || (!state.size && !state.length)) return;
        var slot = this.slots.find((sl) => sl.dataset.sync === 'length' && sl.querySelector('select option[data-size]:not([data-size=""])'));
        if (!slot) return;
        var sel = slot.querySelector('select');
        var opts = Array.prototype.slice.call(sel.options);
        var fits = (o) => (!state.size || o.dataset.size === state.size) && (!state.length || o.dataset.length === state.length);
        var pick = opts.find((o) => fits(o) && o.dataset.available === 'true') || opts.find(fits);
        if (pick && sel.value !== pick.value) {
          sel.value = pick.value;
          this.syncLength(sel);
          this.refresh();
        }
      }
      option(slot) {
        var sel = slot.querySelector('select');
        return sel ? sel.selectedOptions[0] : slot.querySelector('[data-option]');
      }
      syncLength(source) {
        var picked = source.selectedOptions[0];
        var len = picked && picked.dataset.length;
        if (!len) return;
        this.slots.forEach((slot) => {
          var sel = slot.querySelector('select');
          if (!sel || sel === source || slot.dataset.sync !== 'length') return;
          var opts = Array.prototype.slice.call(sel.options);
          var need = Number(len);
          // Exact length first; otherwise the shortest option that is still long enough.
          var longEnough = opts.filter((o) => Number(o.dataset.length) >= need)
            .sort((a, b) => Number(a.dataset.length) - Number(b.dataset.length));
          var exact = longEnough.filter((o) => Number(o.dataset.length) === need);
          var pool = exact.length ? exact : longEnough.filter((o) => o.dataset.length === longEnough[0].dataset.length);
          var match = pool.find((o) => o.dataset.available === 'true') || pool[0];
          if (match) sel.value = match.value;
        });
      }
      refresh() {
        var total = 0, count = 0;
        this.slots.forEach((slot) => {
          var o = this.option(slot);
          var cb = slot.querySelector('input[type="checkbox"]');
          var ok = !!o && o.dataset.available === 'true';
          var on = ok && (!cb || cb.checked);
          slot.classList.toggle('is-soon', !ok);
          slot.classList.toggle('is-off', !on);
          var status = slot.querySelector('[data-status]');
          if (status) status.hidden = ok;
          var price = slot.querySelector('[data-slot-price]');
          if (price && o) price.innerHTML = o.dataset.priceHtml;
          var img = slot.querySelector('[data-slot-img]');
          if (img && o && o.dataset.img) img.src = o.dataset.img;
          if (on) { total += Number(o.dataset.price || 0); count++; }
        });
        if (this.totalEl) this.totalEl.textContent = formatMoney(total);
        if (this.countEl) this.countEl.textContent = count;
        if (this.btn) this.btn.disabled = count === 0;
      }
      add() {
        var items = [];
        this.slots.forEach((slot) => {
          if (slot.classList.contains('is-off')) return;
          var o = this.option(slot);
          if (o) items.push({ id: Number(o.value || o.dataset.value), quantity: 1 });
        });
        if (!items.length) return;
        var label = this.btn.textContent;
        this.btn.disabled = true;
        this.btn.textContent = 'Adding...';
        addItems(items).then(() => {
          var kitMsg = 'Kit added: ' + items.length + ' item' + (items.length === 1 ? '' : 's');
          if (this.dataset.after === 'drawer') {
            showInThemeCart(true).then((shown) => { if (!shown) toast(kitMsg); });
            this.btn.disabled = false; this.btn.textContent = label;
          } else if (this.dataset.after === 'toast') {
            showInThemeCart(false);
            toast('Kit added: ' + items.length + ' item' + (items.length === 1 ? '' : 's'));
            this.btn.disabled = false; this.btn.textContent = label;
          } else {
            window.location.href = routes().cart;
          }
        }).catch((err) => {
          if (this.msg) { this.msg.textContent = err.message; this.msg.hidden = false; }
          this.btn.disabled = false; this.btn.textContent = label;
        });
      }
    });
  }

  /* ---------- Shared filter state (size + length) ---------- */
  var filterState = { size: '', length: '' };

  function sizeLabel(key) {
    // "1/4x3/8" -> 1/4" x 3/8"
    return key ? key.split('x').map(function (p) { return p + '"'; }).join(' x ') : '';
  }

  function applyFilters(updateUrl) {
    var s = filterState.size, l = filterState.length;
    var matches = 0;
    document.querySelectorAll('[data-acc-item]').forEach(function (it) {
      var is = it.dataset.size || '', il = it.dataset.length || '';
      var hide = (s && is && is !== s) || (l && il && il !== l);
      it.hidden = !!hide;
      var hit = !hide && ((s && is === s) || (l && il === l));
      it.classList.toggle('is-match', !!hit);
      if (hit) matches++;
    });
    document.querySelectorAll('[data-acc-group]').forEach(function (g) {
      var any = Array.prototype.some.call(g.querySelectorAll('[data-acc-item]'), function (i) { return !i.hidden; });
      var none = g.querySelector('[data-acc-none]');
      var grid = g.querySelector('.da-acc-grid');
      if (none) none.hidden = any;
      if (grid) grid.hidden = !any;
    });

    var active = !!(s || l);
    // Sync every control on the page
    document.querySelectorAll('select[data-filter]').forEach(function (sel) {
      var v = filterState[sel.dataset.filter] || '';
      if (Array.prototype.some.call(sel.options, function (o) { return o.value === v; })) sel.value = v;
    });
    document.querySelectorAll('[data-filter-chip]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(filterState[btn.dataset.filterChip] === btn.dataset.value));
    });
    document.querySelectorAll('[data-clear]').forEach(function (b) { b.hidden = !active; });
    var parts = [];
    if (s) parts.push(sizeLabel(s));
    if (l) parts.push(l + ' ft');
    document.querySelectorAll('[data-filter-out]').forEach(function (out) {
      out.textContent = active
        ? matches + ' matching item' + (matches === 1 ? '' : 's') + ' for ' + parts.join(' + ') + '. Universal accessories stay visible.'
        : '';
    });
    document.querySelectorAll('da-acc-bundle').forEach(function (b) { if (b.matchFilter) b.matchFilter(filterState); });
    document.dispatchEvent(new CustomEvent('da:filter-changed', { detail: { size: s, length: l, matches: matches } }));

    if (updateUrl && window.history && window.history.replaceState) {
      var u = new URL(window.location.href);
      if (s) u.searchParams.set('size', s); else u.searchParams.delete('size');
      if (l) u.searchParams.set('length', l); else u.searchParams.delete('length');
      window.history.replaceState(null, '', u.toString());
    }
  }

  window.daAccFilter = {
    get: function () { return { size: filterState.size, length: filterState.length }; },
    set: function (partial, updateUrl) {
      if (partial && 'size' in partial) filterState.size = partial.size || '';
      if (partial && 'length' in partial) filterState.length = partial.length || '';
      applyFilters(updateUrl !== false);
    },
    clear: function () { this.set({ size: '', length: '' }); }
  };

  (function readUrl() {
    var q = new URLSearchParams(window.location.search);
    filterState.size = q.get('size') || '';
    filterState.length = q.get('length') || '';
  })();

  /* ---------- "Match your system" panel ---------- */
  if (!customElements.get('da-acc-finder')) {
    customElements.define('da-acc-finder', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-filter-chip]').forEach((btn) => {
          btn.addEventListener('click', () => {
            var key = btn.dataset.filterChip, val = btn.dataset.value;
            var next = {};
            next[key] = filterState[key] === val ? '' : val;
            window.daAccFilter.set(next);
          });
        });
        this.querySelectorAll('[data-clear]').forEach((b) => b.addEventListener('click', () => window.daAccFilter.clear()));
        var go = this.querySelector('[data-see-matches]');
        if (go) go.addEventListener('click', (e) => {
          var first = document.querySelector('[data-acc-item].is-match') || document.querySelector(go.getAttribute('href'));
          if (first) { e.preventDefault(); first.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        });
        // Show how many products each option matches
        this.querySelectorAll('[data-filter-chip]').forEach((btn) => {
          var attr = btn.dataset.filterChip === 'size' ? 'data-size' : 'data-length';
          var n = document.querySelectorAll('[data-acc-item][' + attr + '="' + btn.dataset.value + '"]').length;
          var c = btn.querySelector('[data-chip-count]');
          if (c) c.textContent = n;
          btn.classList.toggle('is-empty', n === 0);
        });
        applyFilters(false);
      }
    });
  }

  /* ---------- Sticky filter + jump bar ---------- */
  if (!customElements.get('da-acc-toolbar')) {
    customElements.define('da-acc-toolbar', class extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('.da-acc-bar');
        this.querySelectorAll('select[data-filter]').forEach((sel) => {
          sel.addEventListener('change', () => {
            var next = {};
            next[sel.dataset.filter] = sel.value;
            window.daAccFilter.set(next);
          });
        });
        this.querySelectorAll('[data-clear]').forEach((b) => b.addEventListener('click', () => window.daAccFilter.clear()));
        applyFilters(false);
        if (this.dataset.sticky === 'true') this.initSticky();
      }
      initSticky() {
        var offset = Number(this.dataset.offset || 0);
        var spacer = document.createElement('div');
        spacer.className = 'da-acc-bar-spacer';
        this.bar.parentNode.insertBefore(spacer, this.bar);
        var ticking = false;
        var check = () => {
          ticking = false;
          var cats = document.querySelectorAll('.da-acc-cat');
          var last = cats[cats.length - 1];
          var top = spacer.getBoundingClientRect().top;
          var barH = this.bar.offsetHeight;
          var endOk = !last || last.getBoundingClientRect().bottom > barH + offset + 40;
          var fixed = top <= offset && endOk;
          this.bar.classList.toggle('is-fixed', fixed);
          this.bar.style.top = fixed ? offset + 'px' : '';
          spacer.style.height = fixed ? barH + 'px' : '0px';
        };
        window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
        window.addEventListener('resize', check);
        check();
      }
    });
  }
})();